import styled from "styled-components";
import {
  CenterContainer,
  LeftContainer,
  FlexibleRowContainer,
} from "../../styles/styles";
import { FixaSkeleton } from "@coworker/apprestructured/src/shared/wrappers/FixaSkeleton/FixaSkeleton";

const SkeletonContainer = styled.div`
  background-color: var(--grey100);
  padding: 32px 0px;
`;

export const MediumSkeletonListItem = () => {
  return (
    <SkeletonContainer>
      <FlexibleRowContainer
        data-testid="skeleton-list-item"
        style={{ padding: "20px 24px", background: "var(--white)" }}
      >
        <LeftContainer>
          <FixaSkeleton height={"48px"} width={"48px"} />
        </LeftContainer>
        <CenterContainer $centerText={false} style={{ gap: "5px" }}>
          <FixaSkeleton height={"14px"} width={"100%"} />
          <FixaSkeleton height={"14px"} width={"100%"} />
          <FixaSkeleton height={"14px"} width={"100%"} />
        </CenterContainer>
      </FlexibleRowContainer>
    </SkeletonContainer>
  );
};
